// removed by extract-text-webpack-plugin
module.exports = {"bg-light-blue":"bg-light-blue__c6c1x","table":"table__RANvZ","desc":"desc__1dg5j"};


//////////////////
// WEBPACK FOOTER
// ./styles/table.scss
// module id = 506
// module chunks = 68